// src/pages/StudentCohortPage.jsx
import React, { useState, useEffect } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { cohortService } from '../api/services';
import DashboardLayout from '../components/layout/DashboardLayout';
import { FolderOpen, Loader2, ArrowRight } from 'lucide-react';
import CohortClassroomPage from './CohortClassroomPage';

const StudentCohortPage = () => {
  const [cohorts, setCohorts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cohortService.getMyCohorts()
      .then((res) => {
        setCohorts(res.data?.data?.cohorts ?? res.data?.cohorts ?? []);
      })
      .catch(() => setCohorts([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <DashboardLayout title="My Cohort">
        <div className="flex items-center justify-center py-20">
          <Loader2 size={32} className="animate-spin text-forest-500" />
        </div>
      </DashboardLayout>
    );
  }

  if (cohorts.length === 0) {
    return (
      <DashboardLayout title="My Cohort">
        <div className="bg-white rounded-2xl p-12 border border-cream-200 text-center space-y-3 max-w-lg mx-auto mt-8">
          <FolderOpen size={40} className="mx-auto text-forest-300" />
          <h3 className="font-serif text-lg font-semibold text-forest-900">Not Assigned to a Cohort</h3>
          <p className="text-xs text-forest-500 leading-relaxed">
            You are currently not enrolled in any cohort classroom. Contact your institution or platform admin to be added.
          </p>
        </div>
      </DashboardLayout>
    );
  }

  // If student belongs to 1 cohort, direct them directly to that classroom!
  if (cohorts.length === 1) {
    return <Navigate to={`/cohorts/${cohorts[0].id}`} replace />;
  }

  // If enrolled in multiple cohorts, let them choose
  return (
    <DashboardLayout title="My Cohorts">
      <div className="space-y-6 max-w-4xl">
        <h2 className="font-serif text-2xl font-bold text-forest-900">My Cohorts</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {cohorts.map((c) => (
            <div key={c.id} className="bg-white rounded-2xl p-5 border border-cream-200 space-y-3">
              <h3 className="font-serif text-lg font-bold text-forest-900">{c.name}</h3>
              {c.description && <p className="text-xs text-forest-500 line-clamp-2">{c.description}</p>}
              <Link to={`/cohorts/${c.id}`} className="btn-primary text-xs py-2 px-3 inline-flex items-center gap-1">
                Enter Classroom <ArrowRight size={12} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default StudentCohortPage;
